import { render } from "./ViewTableComponent.vue?vue&type=template&id=f055399c"
import script from "./ViewTableComponent.vue?vue&type=script&lang=js"
export * from "./ViewTableComponent.vue?vue&type=script&lang=js"
script.render = render

export default script